export var setHeaders = function (customCacheTTL, isBrowser, isStagingRequest, bypassSsrInternalCache, timeout, extendedTimeout) {
    if (isStagingRequest === void 0) { isStagingRequest = false; }
    if (bypassSsrInternalCache === void 0) { bypassSsrInternalCache = false; }
    if (extendedTimeout === void 0) { extendedTimeout = false; }
    var headers = {};
    if (customCacheTTL && !isBrowser) {
        headers['x-wix-site-assets-custom-cache'] = customCacheTTL;
    }
    if (bypassSsrInternalCache) {
        headers['x-wix-bypass-ssr-internal-cache'] = '1';
    }
    if (extendedTimeout && timeout) {
        headers['x-wix-extended-timeout'] = '1';
        headers['x-first-byte-timeout'] = "".concat(timeout, "ms"); // varnish custom timeout
    }
    return headers;
};
